export enum EErrorCodes {
	BAD_REQUEST = 400,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
	PAGE_NOT_FOUND = 404,
	TOO_MANY_REQUESTS = 429,
	INTERNAL_SERVER_ERRROR = 500,
	BAD_GATEWAY = 502,
}
